import AmioHttpService from '@/services/amio/amio-http.service'

// Cross-org admin Indexation Overview (see docs/2026-08-21-admin-section-design.md). Gated by
// verifyAdmin on the engine; the page is only reachable for is-admin users.
class AdminIndexExecutionsService extends AmioHttpService {
  async list({ orgId, status, max, offset } = {}) {
    const params = {}
    if (orgId) params.orgId = orgId
    if (status) params.status = status
    if (max) params.max = max
    if (offset) params.offset = offset

    try {
      const response = await this.requestGet('/admin/index-executions', { params })
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }
}

export default new AdminIndexExecutionsService()
